







































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http";


export interface Data {
  errorKind: string
  errors: string[]
}

export default defineComponent({
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errorKind: null,
      errors: [],
    });

    const onSubmit = async () => {
      context.root.$store.dispatch("showOverlay");
      document.cookie = "api_kind=digital_paper";
      await http.post(`/api/classroom_sessions/create`).then(response => {
        if (response.data.auth_uri) {
          window.location.href = response.data.auth_uri;
        } else {
          state.errors = ["認証URLの取得に失敗しました。"];
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.commit("setBase64SchoolLogo", require("@/assets/images/logo_smarky_ol.png"));

      if(context.root.$route.query.errorKind){
        state.errorKind = context.root.$route.query.errorKind as string;
      }
    });

    return {
      ...toRefs(state),
      onSubmit,
    }
  }
});
